<template>
  <LayoutGame>
    <div class="main" :style="`background-color: ${backgroundColor}`">
      <canvas id="my-coins" height="720" width="960"></canvas>
      <Home />
      <Game />
      <GameOver />
      <Settings />
    </div>
  </LayoutGame>
</template>

<script>
import { mapGetters } from 'vuex';
// import { Howl } from 'howler';
// import lottie from 'lottie-web/build/player/lottie';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'SavingMoney',
  components: {
    Home: () => import('@/components/practices/saving_money/Home.vue'),
    Game: () => import('@/components/practices/saving_money/Game.vue'),
    GameOver: () => import('@/components/practices/saving_money/GameOver.vue'),
    LayoutGame: () => import('@/layouts/LayoutGame.vue'),
    Settings: () => import('@/components/practices/Settings.vue'),
  },
  computed: {
    ...mapGetters({
      backgroundColor: 'savingMoney/backgroundColor',
      currentExercise: 'savingMoney/currentExercise',
      currentLives: 'savingMoney/currentLives',
      exerciseCompleted: 'savingMoney/exerciseCompleted',
      homeScreenStatus: 'savingMoney/homeScreenStatus',
      muteStatus: 'settings/muteStatus',
    }),
  },
  watch: {
    muteStatus: state => {
      if (state) {
        sounds.mute(true);
      } else {
        sounds.mute(false);
      }
    },
  },
  mounted() {
    sounds.savingMoneyBackground.play();
    this.$confetti.start({
      canvasId: 'my-coins',
      defaultSize: 10,
      particlesPerFrame: 0.1,
      particles: [
        {
          type: 'image',
          size: 50,
          url: '/assets/practices/global/confetti/coin.svg',
        },
      ],
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.main {
  @include container;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  color: $saving-money-color-text-main;
  font-size: 5vh;
  font-family: 'THIS FONT IS BOLD Bold', sans-serif;
  height: 100vh;

  #coin-background,
  #my-coins {
    height: 100vh;
    position: absolute;
    opacity: 0.5;
    right: 0;
    width: 75vw;
  }
}
</style>
